import { render, staticRenderFns } from "./UserLabel.vue?vue&type=template&id=73ef4da6&scoped=true&"
import script from "./UserLabel.vue?vue&type=script&lang=js&"
export * from "./UserLabel.vue?vue&type=script&lang=js&"
import style0 from "./UserLabel.vue?vue&type=style&index=0&id=73ef4da6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef4da6",
  null
  
)

export default component.exports